<!--
  @Description: 
  @Author: wang.y 
  @Date: 2024-07-30 
-->
<template>
  <div class="main-container">
    <page-header>{{'获取门票成功' | dealLanguage('Obtained tickets successfully')}}</page-header>
    <div class="center-wrapper">
      <div class="top-tip" v-if="language == 'zh'">您好，感谢您关注<span>{{detail.activityName}}</span>，本届展会采用展前“线上实名预约登记”及现场核验“参会凭证”形式，请务必携带电子参会凭证或打印版参会凭证参会</div>
      <div class="top-tip" v-if="language == 'en'">Hello, thank you for following the <span>{{detail.activityEnName}}</span>,This exhibition adopts the form of "online reservation registration" before the exhibition and on-site verification of "attendance vouchers". Please be sure to bring electronic attendance vouchers or printed attendance vouchers to attend.</div>
      <div class="wrapper-container">
        <div class="view-title">
          <div class="title">{{'电子门票' | dealLanguage('Electronic tickets')}}</div>
          <div class="line"></div>
          <Button type="primary" @click="saveCode">{{'下载电子门票' | dealLanguage('Download')}}</Button>
        </div>
        <div class="ticket-view">
          <ticket-code ref="ticket-code"></ticket-code>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import PageHeader from '@/components/pc/pageHeader.vue'
import ticketCode from '@/components/common/ticketCode.vue'
import { signdetail } from '@/service/vbef'
import { mapState } from 'vuex'
import filter from 'js/filter'
export default {
  metaInfo() {
    return {
      title: filter.dealLanguage('获取门票成功', 'Obtained tickets successfully'),
    }
  },
  components: {
    PageHeader,
    ticketCode,
  },
  created() {},
  mounted() {
    this.getDetail()
  },
  data() {
    return {
      page: 1,
      myticket: [],
      isMore: false,
      detail: {},
    }
  },
  computed: {
    ...mapState({
      user_key: (state) => state.user_key,
      user: (state) => state.user,
      language: (state) => state.language,
    }),
  },
  methods: {
    async getDetail() {
      let res = await signdetail({
        ticketUserRelationId: this.$route.params.id,
        activityOrderId: this.$route.query.orderId || null,
        activityTicketId: this.$route.query.activityTicketId || null,
        verificationCode: this.$route.query.verificationCode || null,
        xuserId: this.$route.query.xuserId || null,
      })
      if (res.code == 0) {
        this.$set(this.$data, 'detail', res.data)
        this.$refs['ticket-code'].setImg(res.data, {
          orderXuserName: this.user.name,
          orderXuserCompName: this.user.compName,
          orderXuserTitle: this.user.title,
        })
      } else {
        this.$Message.error(filter.dealLanguage(res.msg, res.enMsg || res.msg))
      }
    },
    saveCode() {
      this.$refs['ticket-code'].saveCode()
    },
  },
}
</script>
<style lang='stylus' scoped>
@import '~styles/common-pc.styl'
@import '~styles/form-view.styl'
.center-wrapper
  padding 20px 0 30px
  .top-tip
    font-size 16px
    color #3D3D3D
    line-height 22px
    text-align justify
    span
      color #C8161D
  .view-title
    margin-bottom 18px
    .ivu-btn-primary
      color #fff
      background-color #C8161D
      border-color #C8161D
      box-shadow none
      transition all 0.3s
      width 120px
      max-width 120px
      min-width 120px
      height 40px
      font-size 16px
      padding 0
      margin-left 12px
      &:hover
        background-color #E24147
        border-color #E24147
  .wrapper-container
    margin-top 24px
    .ticket-view
      width 686px
      margin 0 auto
</style>